<template>
  <div class="moveDialog">
    <el-dialog
      title="查看回路"
      :visible.sync="status"
      width="30%"
      :close-on-click-modal="false"
    >
      <p style="padding-left: 20px;"><img src="../img/moveIcon.png" />查看回路</p>
      <div class="cir-list">
        <el-table
          :data="cirdata"
          stripe
          style="width: 100%;">
          <el-table-column
            prop="branchName"
            width="200px"
            label="监测回路名称"
          >
          </el-table-column>
          <el-table-column
            prop="status"
            label="状态"
          >
            <template slot-scope="scope">
              <span v-if="scope.row.status==0">
                删除
              </span>
              <span v-if="scope.row.status==1">
               正常
              </span>
              <span v-if="scope.row.status==2">
              故障
              </span>
            </template>
          </el-table-column>
          <el-table-column align="center"  label="操作" >
            <template slot-scope="scope">
              <span  class="dobtn" type="text" @click="todetail(scope.row)">详情</span>
              <span  class="dobtn" type="text" @click="changecir(scope)">编辑</span>

            </template>
          </el-table-column>
        </el-table>
      </div>
    </el-dialog>
    <el-dialog title="编辑回路" :close-on-click-modal="false" :visible.sync="changeCir" width="550px">
      <el-form ref="changeCirFormData" :rules="rules2" :model="cirparam"  label-width="120px">
        <el-form-item label="回路名称" prop="branchName" >
          <el-input v-model="cirparam.branchName" />
        </el-form-item>
        <el-form-item label="监测点选择" prop="monitorSiteId" v-show="!addnew" >
          <el-select style="width: 390px;" filterable  v-model="cirparam.monitorSiteId" placeholder="请选择">
            <el-option
              v-for="item in stationData"
              :key="item.id"
              :label="item.siteName"
              :value="item.id">
            </el-option>
          </el-select>
        </el-form-item>
        <el-form-item label="监测点新增" prop="siteName" v-show="addnew" >
          <el-input v-model="cirparam.siteName" @input="change($event)" />

        </el-form-item>
        <div style="text-align:right;margin-bottom: 20px;" >
          <el-button type="primary" @click="addnewpos()">{{addnew?"选择监测点":"新增监测点"}}</el-button>
        </div>

        <div style="text-align:right;" >
          <el-button type="primary" @click="uploadCir('changeCirFormData')">保存</el-button>
          <el-button @click="changeCir = false">取消</el-button>
        </div>
      </el-form>

    </el-dialog>
  </div>
</template>

<script>
import Axios from "@/utils/Axios";
import Bus from "utils/bus.js";
export default {
  name: "moveDialog",
  data() {
    let validateInput = (rule, value, callback) => {
      if (!this.checkSpecialKey(value)) {
        callback(new Error("不能含有特殊字符"));
      } else {
        callback();
      }
    }
    return {
      status: false,
      changeCir: false,
      addnew: false,
      cirdata:[],
      nowcirdata:{},
      cirparam:{},
      stationData:[],
      rules2:{
        branchName: [
          { required: true, message: '请输入名称', trigger: 'blur' },
        ],
        enableStatus: [
          { required: true, message: '请选择状态', trigger: 'blur' },
        ],
        siteName:[
          { validator: validateInput, trigger: ['blur', 'change']  },//加上这一句
        ],
        siteId:[
          { required: true, message: '请输入名称', trigger: 'blur' },
        ]
      },
    };
  },
  methods: {
    checkSpecialKey(str) {

      let specialKey = "[.。'<{}>]";
      if(str==undefined){
        return true;
      }
      for (let i = 0; i < str.length; i++) {

        if (specialKey.indexOf(str.substr(i, 1)) != -1) {
          return false;
        }
      }
      return true;
    },
    //添加新监测点
    addnewpos(){
      this.addnew=!this.addnew
    },
    change(data){
      this.$forceUpdate()
    },
    //上传编辑的回路信息
    uploadCir(formName){
      this.$refs[formName].validate((valid) => {
        if (valid) {
          let that = this;
          let param = {};
          param.method="post";
          param.url="/branch/modify";
          param.data=  {
            branchId:this.cirparam.branchId,
            branchName:this.cirparam.branchName,

          }
          if(this.addnew){
            param.data.siteId=-1
            // param.data.siteId=this.cirparam.monitorSiteId
            param.data.siteName=this.cirparam.siteName
          }else{
            param.data.siteId=this.cirparam.monitorSiteId
          }


          Axios.ajax(param).then((res)=>{

            if(res.resultCode=='0'){
              this.$message({
                type: 'success',
                message: "修改成功"
              });
              this.lookcircuit(this.nowcirdata.terminalId)
              // this.getTableData()
              this.changeCir=false
            }else{
              this.$message({
                type: 'error',
                message: res.msg
              });
            }

          })
        }})
    },
    //获取所有监测点列表
    opentc(id,monitorSiteId){

      if(monitorSiteId==null){
        this.addnew=true
      }else{
        this.addnew=false

      }
      let that = this;
      let param = {};
      param.method="get";
      param.url="/monitor/queryListAll";
      param.params={
        deptId:id
      }
      Axios.ajax(param).then((res)=>{

        if(res.data){
          that.stationData=res.data
          if(res.data.length==0){

            this.cirparam.siteName=that.cirparam.branchName

          }
        }
      })
    },
    //编辑回路
    changecir(data){

      this.cirparam=data.row
      this.changeCir=true
      this.opentc(data.row.deptId,data.row.monitorSiteId)
    },
    todetail(data){

      if(data.monitorSiteId){
        this.$router.push({
          name:"stationListPage",
          params:{
            val:[data.branchName+'详情',data.branchId, data.monitorSiteId,"/dataDetail"]
            // val:"666"

          },

        });
        Bus.$emit('changeheader', '2')
      }else{
        this.$message.warning("当前回路暂无绑定监测点！");
      }

      // sessionStorage.setItem("branchId", data.branchId);
      // sessionStorage.setItem("terminalTypeName", data.terminalTypeName);
      // sessionStorage.setItem("imei", data.imei);


      // Bus.$emit('pushrouter3', [data.branchName+'详情',data.branchId, data.monitorSiteId,"/dataDetail"])

    },
    lookcircuit(terminalId){

      let that = this;
      let param = {};
      param.method="get";
      param.url="/branch/query";
      param.params={
        "terminalId":terminalId,

      }
      Axios.ajax(param).then((res)=>{

        if(res.data){
          that.cirdata=res.data


        }

      })
    },
    controlDialog(data) {
      this.status = true;
      this.nowcirdata=data
      this.lookcircuit(data.terminalId)
    },
  },
};
</script>

<style lang="less" scoped>
.moveDialog {
  p {
    margin: 0 0 10px 0;
    height: 30px;
    line-height: 10px;
    img {
      margin-right: 12px;
    }
  }
  .dobtn{
    width: 50px;
    height: 28px;
    text-align: center;
    line-height: 28px;
    display: inline-block;
    background-color:#409eff ;
    border-color: #409eff;
    border-radius: 4px;
    color: #fff;
    cursor: pointer;
    margin-left: 10px;
  }
}
</style>
